import * as React from 'react';
import PropTypes from 'prop-types';

export const PoNumber = props => {
  return (
    <div style={{ marginTop: '20px' }}>
      <b>New PO Number</b>
      <ul>
        <li>{props.new_po_number}</li>
      </ul>
    </div>
  );
};

PoNumber.propTypes = {
  new_po_number: PropTypes.string.isRequired,
};
